module.exports = require("./dirPagination.js");
require("./dirPagination.tpl.html");


//////////////////
// WEBPACK FOOTER
// angularUtils-pagination (bower component)
// module id = 428
// module chunks = 0